import { showGlobalDialogError } from "../components/error";
import { apiClient } from "./apiClient.services";

function getAuthData() {
	return {
		businessId: localStorage.getItem("businessId"),
	};
}

export const PostHelp = async (value) => {
	const { businessId } = getAuthData();
	try {
		let result = await apiClient(`/core/support-tickets${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`, {
			method: "POST",
			body: value
		});
		if (!result) return { response: { ok: false, status: 400 }, result: null };
		return { response: { ok: true, status: 200 }, result };
	} catch (e) {
		throw e;
	}
}

export const GetSupportHistory = async (page = 0, size = 10) => {
    const { businessId } = getAuthData();
    try {
        const adjustedPage = page + 1;
        return await apiClient(`/core/support-tickets${localStorage.getItem("businessId") ? `?businessId=${businessId}` : '?'}&page=${adjustedPage}&size=${size}`);
    } catch (e) {
        showGlobalDialogError();
    }
}

export const GetSingleSupportHistory = async (value) => {
    const { businessId } = getAuthData();
    try {
        return await apiClient(`/core/support-tickets/${value}${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`);
    } catch (e) {
        showGlobalDialogError();
    }
}

export const CancelRequest = async (value) => {
	const { businessId } = getAuthData();
	try {
		let result = await apiClient(`/core/support-tickets/update-status${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`, {
			method: "POST",
			body: value
		});
		return { ok: !!result };
	} catch (e) {
		throw e;
	}
}